import React, { FunctionComponent } from 'react'
import { ITermosOnboarding } from 'modules/pagamentos/domain/usecases/TermosOnboarding'
import { IAceitarTermosOnboarding } from 'modules/pagamentos/domain/usecases/AceitarTermosOnboarding'
import { IEnviarDocumentoOnboarding } from 'modules/pagamentos/domain/usecases/EnviarDocumentoOnboarding'
import { ICreateContaPJOnboarding } from 'modules/pagamentos/domain/usecases/CreateContaPJOnboarding'
import { IConfirmarEnvioDocumentosOnboarding } from 'modules/pagamentos/domain/usecases/ConfirmarEnvioDocumentosOnboarding'
import Stepper from 'shared/components/Stepper'
import DadosGerais from './DadosGerais'
import Representante from './Representante'
import Documentos from './Documentos'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'
import { Container } from './styles'
import { Grid } from '@material-ui/core'
import Validacao from './Validacao'
import { IConsultZipCode } from 'modules/user/domain/usecases/ConsultZipCodeImpl'
import { IValidarPinTmovPay } from 'modules/pagamentos/domain/usecases/ValidarPinTmovPay'
import { IEnviarPinTmovPay } from 'modules/pagamentos/domain/usecases/EnviarPinTmovPay'
import CadastroFinalizado from './CadastroFinalizado'
import PorcentagemTrasferencias from '../components/PorcentagemTransferencia'
import { IUpdatePercentualTransferenciaMotorista } from 'modules/pagamentos/domain/usecases/UpdatePercentualTransferenciaMotorista'
import { IGetPercentualTransferenciaMotorista } from 'modules/pagamentos/domain/usecases/GetPercentualTransferenciaMotorista'

interface OnboardingProps {
  termosAceiteOnboarding: ITermosOnboarding
  aceitarTermosDeUsoOnboarding: IAceitarTermosOnboarding
  enviarDocumentoOnboarding: IEnviarDocumentoOnboarding
  createContaPJOnboarding: ICreateContaPJOnboarding
  confirmarEnvioDocumentosOnboarding: IConfirmarEnvioDocumentosOnboarding
  enviarPinTmovPay: IEnviarPinTmovPay
  validarPinTmovPay: IValidarPinTmovPay
  consultZipCode: IConsultZipCode
  updatePercentualTransferenciaMotorista: IUpdatePercentualTransferenciaMotorista
  getPercentualTransferenciaMotorista: IGetPercentualTransferenciaMotorista
}
const Onboarding: FunctionComponent<OnboardingProps> = ({
  termosAceiteOnboarding,
  aceitarTermosDeUsoOnboarding,
  enviarDocumentoOnboarding,
  createContaPJOnboarding,
  confirmarEnvioDocumentosOnboarding,
  enviarPinTmovPay,
  validarPinTmovPay,
  consultZipCode,
  updatePercentualTransferenciaMotorista,
  getPercentualTransferenciaMotorista,
}) => {
  const { step, success, showPercentualTransferencia } = useOnboarding()
  const components = [
    {
      component: (
        <DadosGerais termosAceiteOnboarding={termosAceiteOnboarding} />
      ),
    },
    {
      component: <Representante consultZipCode={consultZipCode} />,
    },
    {
      component: <Documentos />,
    },
    {
      component: (
        <Validacao
          aceitarTermosDeUsoOnboarding={aceitarTermosDeUsoOnboarding}
          enviarDocumentoOnboarding={enviarDocumentoOnboarding}
          createContaPJOnboarding={createContaPJOnboarding}
          confirmarEnvioDocumentosOnboarding={
            confirmarEnvioDocumentosOnboarding
          }
          enviarPinTmovPay={enviarPinTmovPay}
          validarPinTmovPay={validarPinTmovPay}
        />
      ),
    },
  ]

  if (showPercentualTransferencia)
    return (
      <PorcentagemTrasferencias
        updatePercentualTransferenciaMotorista={
          updatePercentualTransferenciaMotorista
        }
        getPercentualTransferenciaMotorista={
          getPercentualTransferenciaMotorista
        }
        showScaffold={false}
      />
    )

  if (success) return <CadastroFinalizado />

  return (
    <Container>
      <Stepper
        step={step}
        data={['Dados gerais', 'Representante', 'Documentos', 'Validação']}
      />
      <Grid style={{ padding: 16 }}>{components[step]?.component}</Grid>
    </Container>
  )
}

export default Onboarding
